import React from 'react';
import {SelectInput} from 'react-admin';

const type = [
    {id: 'Không', name: 'Không'},
    {id: 'Toán', name: 'Toán'},
    {id: 'Lý', name: 'Lý'},
    {id: 'Hoá', name: 'Hoá'},
    {id: 'Sinh', name: 'Sinh'},
    {id: 'Sử', name: 'Sử'},
    {id: 'Địa', name: 'Địa'},
    {id: 'Văn', name: 'Văn'},
    {id: 'Anh', name: 'Anh'},
    {id: 'Tin', name: 'Tin'}
]

export const MonChuyenInput = (props) => (
    <SelectInput source={props.source} choices={type} {...props} />
)
